<template>

    <header>

      <nav class="navbar navbar-expand-lg fixed-top">
          <a href="#" class="navbar-brand">
            <div v-if="main.logo"><img src="../assets/logo.png" alt="logo" id="logo"></div>
            <div v-if="!main.logo">
              <span id="FirstName">{{main.name.first}}</span> <span id="LastName">{{main.name.last}}</span>
            </div>
          </a>

          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon"><i class="fas fa-bars" style="color:#fff; font-size:28px;"></i></span>
        </button>
        <div id="navbarNavAltMarkup" class="collapse navbar-collapse">
            <ul id="navbar-nav" class="navbar-nav ml-auto">
                <li class="active-nav">
                    <a class="nav-item nav-link" href="#">Home</a>
                </li>
                <li><a class="nav-item nav-link" href="#about">About</a></li>
                <li><a class="nav-item nav-link" href="#skills">Skills</a></li>
                <li><a class="nav-item nav-link" href="#portfolio">Portfolio</a></li>
                <li><a class="nav-item nav-link" href="#contact">Contact</a></li>
            </ul>
        </div>
      </nav>


        <section id="homeview">

            <div class="container-fluid homeview">

                <div class="row">

                    <div 
                    class="col-sm-12 col-md-5"
                    data-aos="fade-down-right"
                    data-aos-duration="1000"
                    >
                        <div class="about-me">

                            <div class="text-one">
                                <h1>{{ name.first }} {{ name.last }}</h1>
                                
                                <h3>
                                    <span class="typed-text">{{ typeValue }}</span> 
                                    <span class="cursor" :class="{'typing': typeStatus}">&nbsp;</span>
                                </h3>
                            </div>

                            <div class="text-two">
                                <!-- 
                                <p>Hi, I'm Zuzana, a web developer based in Esbjerg, Denmark. I enjoy creating things that live on the internet, whether that be websites, applications, or anything in between. My goal is to always build products that provide pixel-perfect, performant experiences.</p> 
                                -->

                                <h5>{{ motivation.text }}</h5>
                                <h5>Visit my <a href="#portfolio">projects</a> and <a href="#contact">contact me</a>.</h5>
                            </div>

                        </div>
                    </div>

                    <div class="col-sm-12 col-md-7">
                        <div 
                        class="mockup-image"
                        data-aos="fade-up-left"
                        data-aos-duration="1000"
                        >
                            <img id="mockup-hero" src="../assets/images/mockup.png" alt="mockup image">
                        </div>
                    </div>

                </div>
                
            </div>

        </section>
      
    </header>



</template>


<script>

import data from "../data/data.json";

export default {
name: "HomeView",
data: () => {
  return {
    main: data.main,
    name: data.main.name,
    motivation: data.main.motivate,
    typeValue: '',
    typeStatus: false,
    typeArray : data.main.titles,
    typingSpeed: 90,
    erasingSpeed: 40,
    newTextDelay: 800,
    typeArrayIndex: 0,
    charIndex: 0
  }
},
methods: {
  typeText() {
    if(this.charIndex < this.typeArray[this.typeArrayIndex].length) {
      if(!this.typeStatus)
        this.typeStatus = true;
      this.typeValue += this.typeArray[this.typeArrayIndex].charAt(this.charIndex);
      this.charIndex += 1;
      setTimeout(this.typeText, this.typingSpeed);
    }
    else {
      this.typeStatus = false;
      setTimeout(this.eraseText, this.newTextDelay);
    }
  },
  eraseText() {
    if(this.charIndex > 0) {
      if(!this.typeStatus)
        this.typeStatus = true;
      this.typeValue = this.typeArray[this.typeArrayIndex].substring(0, this.charIndex - 1);
      this.charIndex -= 1;
      setTimeout(this.eraseText, this.erasingSpeed);
    }
    else {
      this.typeStatus = false;
      this.typeArrayIndex += 1;
      if(this.typeArrayIndex >= this.typeArray.length)
        this.typeArrayIndex = 0;
      setTimeout(this.typeText, this.typingSpeed + 1000);
    }
  }
},
created() {
  setTimeout(this.typeText, this.newTextDelay + 200);
}
}
</script>


